function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

import React from 'react';
import { Link } from 'gatsby';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";

var _ref = process.env.NODE_ENV === "production" ? {
  name: "14mqo2n",
  styles: "display:inline-block;position:relative;left:1rem;width:calc(100% - 1.5rem);color:black;font-family:Roboto Mono, monospace;font-weight:300;font-size:0.8rem;line-height:1.5rem;text-decoration:none;&:hover{color:black;text-decoration:none;&:before{visibility:visible;transform:scaleY(1);}}&:before{background-color:#F486CA;content:' ';position:absolute;width:1px;height:100%;top:0;left:-5px;visibility:hidden;transform:scaleY(0.3);transition:all 0.3s ease-in-out 0s;}&.active{color:black;font-family:Roboto Mono, monospace;font-weight:500;font-size:0.8rem;transition:color 0.2s ease-in-out 0s;}"
} : {
  name: "r1n3w2-NavigationLink",
  styles: "display:inline-block;position:relative;left:1rem;width:calc(100% - 1.5rem);color:black;font-family:Roboto Mono, monospace;font-weight:300;font-size:0.8rem;line-height:1.5rem;text-decoration:none;&:hover{color:black;text-decoration:none;&:before{visibility:visible;transform:scaleY(1);}}&:before{background-color:#F486CA;content:' ';position:absolute;width:1px;height:100%;top:0;left:-5px;visibility:hidden;transform:scaleY(0.3);transition:all 0.3s ease-in-out 0s;}&.active{color:black;font-family:Roboto Mono, monospace;font-weight:500;font-size:0.8rem;transition:color 0.2s ease-in-out 0s;};label:NavigationLink;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var NavigationLink = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return _jsx(Link, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    css: _ref,
    children: props.children
  }));
}); // const NavigationLink = styled(Link)(props => ({
//   display: 'inline-block',
//   position: 'relative',
//   left: '1rem',
//   width: 'calc(100% - 1.5rem)',
//   color: 'black',
//   fontFamily: 'Roboto Mono, monospace',
//   fontWeight: '300',
//   fontSize: '0.8rem',
//   textDecoration: 'none',
//   '&:hover': {
//     color: 'black',
//     textDecoration: 'none',
//     '&:before': {
//       visibility: 'visible',
//       transform: 'scaleY(1)'
//     }
//   },
//   '&:before': {
//     backgroundColor: '#F486CA',
//     content: "' '",
//     position: 'absolute',
//     width: '1px',
//     height: '100%',
//     top: 0,
//     left: '-5px',
//     visibility: 'hidden',
//     transform: 'scaleY(0.3)',
//     transition: 'all 0.3s ease-in-out 0s'
//   },
//   '&.active': {
//     color: 'black',
//     fontFamily: 'Roboto Mono, monospace',
//     fontWeight: '500',
//     fontSize: '0.8rem',
//     transition: 'color 0.2s ease-in-out 0s'
//   }
// }))

export { NavigationLink };